// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blue-header{
    background: #00a6c6;
    padding: 10px 17px;
    color: #fff;
}

.business-details{
    
}
.business-details .single-detail{
    padding: 10px 15px;
/*    border: 1px solid #d3d3d3;*/
    border-top: none;
    border-bottom: none;
}


    .blue-header{
    background: #00a6c6;
    padding: 10px 17px;
    color: #fff;
}

.business-details{
    
}
.business-details .single-detail{
    padding: 10px 15px;
/*    border: 1px solid #d3d3d3;*/
    border-top: none;
    border-bottom: none;
}

.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    
    vertical-align: middle;
}
.table { 
    margin-bottom: 0px;
 }
#recent-reports{
    table-layout: fixed;
    width: 100%
}
#recent-reports th:first-child{
    width: 150px;
}
#recent-reports th:nth-child(2){
    width: 180px;
}
#recent-reports th:nth-child(3){
    width: 235px;
}
#recent-reports th:nth-child(4){
    width: 202px;
}
#recent-reports th:nth-child(5){
    width: 180px;
}
#recent-reports th:nth-child(6){
    width: 233px;
}
#recent-reports th:last-child{
    width: 70px;
}
#recent-reports tbody tr.report-plan-a{
    background: #f5f5f5;
}

.report-plan-arrow{
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;
    padding: 6px 9px;
}
.padding0{
    padding: 0px;
}
.rounded-num{
    background: #0575b5;
    padding: 3px 0px !important;
    color: #fff;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-right: 2px;
}
.report-action-btn span{
  
    padding: 5px;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
}
.report-plan-arrow{
    border-color: #00a6c6;
    color: #00a6c6;
}
.text-wrap{
    white-space: nowrap;
    width: 40em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
}
.text-wrap1{
    white-space: nowrap;
    width: 7em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
}
.pdficon img{}
    .pdficon{background: transparent !important;
        padding: 0 !important;}
        .xlsicon img{    }
        img {
            vertical-align: top;
        }
        .report-plan-a .report-action-btn{   background: #509fcc;
            width: 151px;
            height: 28px;
            border-radius: 15px;
            text-align: center;
            float: left;}
            table tr td:nth-child(5){width: 100px;}
            table tr th:nth-child(5){width: 100px;}
            .charticon{float: left; padding-left: 20px;}
            .report-action-btn{background:#3cc5d3;   
                width: 151px;
                height: 28px;
                border-radius: 15px;
                text-align: center;
                float: left;}
            .report-scenario table tr td:first-child{width: 20px}
            .report-scenario table tr td:nth-child(2){    width: 264px; max-width: 235px;}
            .report-scenario table tr td:nth-child(3){    width: 620px!important;
                max-width: 645px;}
                .pagination>li>a, .pagination>li>span {
                    border-radius: 50% !important;
                    padding: 5px 0 0 0;
                    height: 27px;
                    width: 27px;
                    text-align: center;
                    margin: 5px 5px 0 0;
                    font-size: 13px;border: none;color: #fff;background: #bcbec0;
                }
                .pagination {    
                    margin: 0;
                  
                }
                .report-plan-a td{padding: 6px 20px;}
                .sce_complete{    background: #0575b5 !important;     }
               .sce_draft{background: #f69a9b !important; }
               .report-scenario table{margin-bottom: 0px;}
               .text-default tr th{    padding: 20px 20px;background: #d9d9d9;}
               .sce-incompledted{
                    background: #bcbec0;
                    padding: 3px 5px;
                    color: #fff;
                    border-radius: 50%;
                    width: 26px;
                    height: 25px;
                    display: inline-block;
                    text-align: center;
                    vertical-align: middle;
                    margin-right: 2px;
                    margin-bottom: 2px;
                    position: relative;
               }
               .sce-draft{
                    background: orange;
                    padding: 3px 5px;
                    color: #fff;
                    border-radius: 50%;
                    width: 26px;
                    height: 25px;
                    display: inline-block;
                    text-align: center;
                    vertical-align: middle;
                    margin-right: 2px;
                    position: relative;
               }
               #confirmDelete, #successMsg, #warningOK{
                   top: 200px;vertical-align: middle;
               }
    

#recent-reports{
    table-layout: fixed;
    width: 100%
}
#recent-reports th:first-child{
    width: 150px;
}
#recent-reports th:nth-child(2){
    width: 180px;
}
#recent-reports th:nth-child(3){
    width: 235px;
}
#recent-reports th:nth-child(4){
    width: 202px;
}
#recent-reports th:nth-child(5){
    width: 180px;
}
#recent-reports th:nth-child(6){
    width: 233px;
}
#recent-reports th:last-child{
    width: 70px;
}
#recent-reports tbody tr.report-plan-a{
    background: #f5f5f5;
}

.report-plan-arrow{
    border-radius: 50%;
    height: 30px;
    width: 30px;
    text-align: center;
    padding: 6px 9px;
}
.padding0{
    padding: 0px;
}
.rounded-num{
    background: #0575b5;
    padding: 3px 5px;
    color: #fff;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-right: 2px;
}
.report-action-btn span{
  
    padding: 5px;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
}
.report-plan-arrow{
    border-color: #00a6c6;
    color: #00a6c6;
}
.text-wrap{
    white-space: nowrap;
    width: 27em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
}
.text-wrap1{
    white-space: nowrap;
    width: 7em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
}
.pdficon img{}
    .pdficon{background: transparent !important;
        padding: 0 !important;}
        .xlsicon img{    }
        img {
            vertical-align: top;
        }
        .report-plan-a .report-action-btn{   background: #509fcc;
            width: 151px;
            height: 28px;
            border-radius: 15px;
            text-align: center;
            float: left;}
            table tr td:nth-child(5){width: 100px;}
            table tr th:nth-child(5){width: 100px;}
            .charticon{float: left; padding-left: 20px;}
            .report-action-btn{background:#3cc5d3;   
                width: 151px;
                height: 28px;
                border-radius: 15px;
                text-align: center;
                float: left;}
            .report-scenario table tr td:first-child{width: 20px}
            .report-scenario table tr td:nth-child(2){    width: 264px; max-width: 235px;}
            .report-scenario table tr td:nth-child(3){    width: 620px!important;
                max-width: 645px;}
                .pagination>li>a, .pagination>li>span {
                    border-radius: 50% !important;
                    padding: 5px 0 0 0;
                    height: 27px;
                    width: 27px;
                    text-align: center;
                    margin: 5px 5px 0 0;
                    font-size: 13px;border: none;color: #fff;background: #bcbec0;
                }
                .pagination {    
                    margin: 0;
                  
                }
                .report-plan-a td{padding: 6px 20px;}
                .sce_complete{    background: #0575b5 !important;     }
               .sce_draft{background: #f69a9b !important; }
               .report-scenario table{margin-bottom: 0px;}
               .text-default tr th{    padding: 20px 20px;background: #d9d9d9;}
               .sce-incompledted{
                    background: #bcbec0;
                    padding: 3px 5px;
                    color: #fff;
                    border-radius: 50%;
                    width: 26px;
                    height: 25px;
                    display: inline-block;
                    text-align: center;
                    vertical-align: middle;
                    margin-right: 2px;
                    position: relative;
               }
               .sce-draft{
                    background: orange;
                    padding: 3px 5px;
                    color: #fff;
                    border-radius: 50%;
                    width: 26px;
                    height: 25px;
                    display: inline-block;
                    text-align: center;
                    vertical-align: middle;
                    margin-right: 2px;
                    position: relative;
               }
               #confirmDelete, #successMsg, #warningOK{
                   top: 200px;
               }
               .navbar-nav>li>a{
                padding-top: 0px;
                padding-bottom: 0px;
                padding-left: 0px;
                font-size: 13px;
                margin-left: -7px;
            
            }
            .nav>li>a>img {
                max-width: none;
                width: 32px;
                margin-right: 0px;
                margin-bottom: 3px;

            }

            .draft{
                background:#9A0A35;
              }
              
              #recent-reports td{word-wrap: break-word;}`, "",{"version":3,"sources":["webpack://./src/app/customer-details/customer-details.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;AAEA;AACA;IACI,kBAAkB;AACtB,iCAAiC;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;;IAGI;IACA,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;AAEA;AACA;IACI,kBAAkB;AACtB,iCAAiC;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;CACrB;AACD;IACI,mBAAmB;IACnB;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;;IAEI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA,aAAa;IACT,SAAS,kCAAkC;QACvC,qBAAqB,CAAC;QACtB,iBAAiB;QACjB;YACI,mBAAmB;QACvB;QACA,qCAAqC,mBAAmB;YACpD,YAAY;YACZ,YAAY;YACZ,mBAAmB;YACnB,kBAAkB;YAClB,WAAW,CAAC;YACZ,yBAAyB,YAAY,CAAC;YACtC,yBAAyB,YAAY,CAAC;YACtC,WAAW,WAAW,EAAE,kBAAkB,CAAC;YAC3C,mBAAmB,kBAAkB;gBACjC,YAAY;gBACZ,YAAY;gBACZ,mBAAmB;gBACnB,kBAAkB;gBAClB,WAAW,CAAC;YAChB,yCAAyC,WAAW;YACpD,8CAA8C,YAAY,EAAE,gBAAgB,CAAC;YAC7E,8CAA8C,sBAAsB;gBAChE,gBAAgB,CAAC;gBACjB;oBACI,6BAA6B;oBAC7B,kBAAkB;oBAClB,YAAY;oBACZ,WAAW;oBACX,kBAAkB;oBAClB,mBAAmB;oBACnB,eAAe,CAAC,YAAY,CAAC,WAAW,CAAC,mBAAmB;gBAChE;gBACA;oBACI,SAAS;;gBAEb;gBACA,kBAAkB,iBAAiB,CAAC;gBACpC,kBAAkB,8BAA8B,MAAM;eACvD,WAAW,8BAA8B,EAAE;eAC3C,uBAAuB,kBAAkB,CAAC;eAC1C,wBAAwB,kBAAkB,CAAC,mBAAmB,CAAC;eAC/D;oBACK,mBAAmB;oBACnB,gBAAgB;oBAChB,WAAW;oBACX,kBAAkB;oBAClB,WAAW;oBACX,YAAY;oBACZ,qBAAqB;oBACrB,kBAAkB;oBAClB,sBAAsB;oBACtB,iBAAiB;oBACjB,kBAAkB;oBAClB,kBAAkB;eACvB;eACA;oBACK,kBAAkB;oBAClB,gBAAgB;oBAChB,WAAW;oBACX,kBAAkB;oBAClB,WAAW;oBACX,YAAY;oBACZ,qBAAqB;oBACrB,kBAAkB;oBAClB,sBAAsB;oBACtB,iBAAiB;oBACjB,kBAAkB;eACvB;eACA;mBACI,UAAU,CAAC,sBAAsB;eACrC;;;AAGf;IACI,mBAAmB;IACnB;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;;IAEI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA,aAAa;IACT,SAAS,kCAAkC;QACvC,qBAAqB,CAAC;QACtB,iBAAiB;QACjB;YACI,mBAAmB;QACvB;QACA,qCAAqC,mBAAmB;YACpD,YAAY;YACZ,YAAY;YACZ,mBAAmB;YACnB,kBAAkB;YAClB,WAAW,CAAC;YACZ,yBAAyB,YAAY,CAAC;YACtC,yBAAyB,YAAY,CAAC;YACtC,WAAW,WAAW,EAAE,kBAAkB,CAAC;YAC3C,mBAAmB,kBAAkB;gBACjC,YAAY;gBACZ,YAAY;gBACZ,mBAAmB;gBACnB,kBAAkB;gBAClB,WAAW,CAAC;YAChB,yCAAyC,WAAW;YACpD,8CAA8C,YAAY,EAAE,gBAAgB,CAAC;YAC7E,8CAA8C,sBAAsB;gBAChE,gBAAgB,CAAC;gBACjB;oBACI,6BAA6B;oBAC7B,kBAAkB;oBAClB,YAAY;oBACZ,WAAW;oBACX,kBAAkB;oBAClB,mBAAmB;oBACnB,eAAe,CAAC,YAAY,CAAC,WAAW,CAAC,mBAAmB;gBAChE;gBACA;oBACI,SAAS;;gBAEb;gBACA,kBAAkB,iBAAiB,CAAC;gBACpC,kBAAkB,8BAA8B,MAAM;eACvD,WAAW,8BAA8B,EAAE;eAC3C,uBAAuB,kBAAkB,CAAC;eAC1C,wBAAwB,kBAAkB,CAAC,mBAAmB,CAAC;eAC/D;oBACK,mBAAmB;oBACnB,gBAAgB;oBAChB,WAAW;oBACX,kBAAkB;oBAClB,WAAW;oBACX,YAAY;oBACZ,qBAAqB;oBACrB,kBAAkB;oBAClB,sBAAsB;oBACtB,iBAAiB;oBACjB,kBAAkB;eACvB;eACA;oBACK,kBAAkB;oBAClB,gBAAgB;oBAChB,WAAW;oBACX,kBAAkB;oBAClB,WAAW;oBACX,YAAY;oBACZ,qBAAqB;oBACrB,kBAAkB;oBAClB,sBAAsB;oBACtB,iBAAiB;oBACjB,kBAAkB;eACvB;eACA;mBACI,UAAU;eACd;eACA;gBACC,gBAAgB;gBAChB,mBAAmB;gBACnB,iBAAiB;gBACjB,eAAe;gBACf,iBAAiB;;YAErB;YACA;gBACI,eAAe;gBACf,WAAW;gBACX,iBAAiB;gBACjB,kBAAkB;;YAEtB;;YAEA;gBACI,kBAAkB;cACpB;;cAEA,mBAAmB,qBAAqB,CAAC","sourcesContent":[".blue-header{\r\n    background: #00a6c6;\r\n    padding: 10px 17px;\r\n    color: #fff;\r\n}\r\n\r\n.business-details{\r\n    \r\n}\r\n.business-details .single-detail{\r\n    padding: 10px 15px;\r\n/*    border: 1px solid #d3d3d3;*/\r\n    border-top: none;\r\n    border-bottom: none;\r\n}\r\n\r\n\r\n    .blue-header{\r\n    background: #00a6c6;\r\n    padding: 10px 17px;\r\n    color: #fff;\r\n}\r\n\r\n.business-details{\r\n    \r\n}\r\n.business-details .single-detail{\r\n    padding: 10px 15px;\r\n/*    border: 1px solid #d3d3d3;*/\r\n    border-top: none;\r\n    border-bottom: none;\r\n}\r\n\r\n.table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {\r\n    \r\n    vertical-align: middle;\r\n}\r\n.table { \r\n    margin-bottom: 0px;\r\n }\r\n#recent-reports{\r\n    table-layout: fixed;\r\n    width: 100%\r\n}\r\n#recent-reports th:first-child{\r\n    width: 150px;\r\n}\r\n#recent-reports th:nth-child(2){\r\n    width: 180px;\r\n}\r\n#recent-reports th:nth-child(3){\r\n    width: 235px;\r\n}\r\n#recent-reports th:nth-child(4){\r\n    width: 202px;\r\n}\r\n#recent-reports th:nth-child(5){\r\n    width: 180px;\r\n}\r\n#recent-reports th:nth-child(6){\r\n    width: 233px;\r\n}\r\n#recent-reports th:last-child{\r\n    width: 70px;\r\n}\r\n#recent-reports tbody tr.report-plan-a{\r\n    background: #f5f5f5;\r\n}\r\n\r\n.report-plan-arrow{\r\n    border-radius: 50%;\r\n    height: 30px;\r\n    width: 30px;\r\n    text-align: center;\r\n    padding: 6px 9px;\r\n}\r\n.padding0{\r\n    padding: 0px;\r\n}\r\n.rounded-num{\r\n    background: #0575b5;\r\n    padding: 3px 0px !important;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    width: 25px;\r\n    height: 25px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    margin-right: 2px;\r\n}\r\n.report-action-btn span{\r\n  \r\n    padding: 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n.report-plan-arrow{\r\n    border-color: #00a6c6;\r\n    color: #00a6c6;\r\n}\r\n.text-wrap{\r\n    white-space: nowrap;\r\n    width: 40em;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n.text-wrap1{\r\n    white-space: nowrap;\r\n    width: 7em;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n.pdficon img{}\r\n    .pdficon{background: transparent !important;\r\n        padding: 0 !important;}\r\n        .xlsicon img{    }\r\n        img {\r\n            vertical-align: top;\r\n        }\r\n        .report-plan-a .report-action-btn{   background: #509fcc;\r\n            width: 151px;\r\n            height: 28px;\r\n            border-radius: 15px;\r\n            text-align: center;\r\n            float: left;}\r\n            table tr td:nth-child(5){width: 100px;}\r\n            table tr th:nth-child(5){width: 100px;}\r\n            .charticon{float: left; padding-left: 20px;}\r\n            .report-action-btn{background:#3cc5d3;   \r\n                width: 151px;\r\n                height: 28px;\r\n                border-radius: 15px;\r\n                text-align: center;\r\n                float: left;}\r\n            .report-scenario table tr td:first-child{width: 20px}\r\n            .report-scenario table tr td:nth-child(2){    width: 264px; max-width: 235px;}\r\n            .report-scenario table tr td:nth-child(3){    width: 620px!important;\r\n                max-width: 645px;}\r\n                .pagination>li>a, .pagination>li>span {\r\n                    border-radius: 50% !important;\r\n                    padding: 5px 0 0 0;\r\n                    height: 27px;\r\n                    width: 27px;\r\n                    text-align: center;\r\n                    margin: 5px 5px 0 0;\r\n                    font-size: 13px;border: none;color: #fff;background: #bcbec0;\r\n                }\r\n                .pagination {    \r\n                    margin: 0;\r\n                  \r\n                }\r\n                .report-plan-a td{padding: 6px 20px;}\r\n                .sce_complete{    background: #0575b5 !important;     }\r\n               .sce_draft{background: #f69a9b !important; }\r\n               .report-scenario table{margin-bottom: 0px;}\r\n               .text-default tr th{    padding: 20px 20px;background: #d9d9d9;}\r\n               .sce-incompledted{\r\n                    background: #bcbec0;\r\n                    padding: 3px 5px;\r\n                    color: #fff;\r\n                    border-radius: 50%;\r\n                    width: 26px;\r\n                    height: 25px;\r\n                    display: inline-block;\r\n                    text-align: center;\r\n                    vertical-align: middle;\r\n                    margin-right: 2px;\r\n                    margin-bottom: 2px;\r\n                    position: relative;\r\n               }\r\n               .sce-draft{\r\n                    background: orange;\r\n                    padding: 3px 5px;\r\n                    color: #fff;\r\n                    border-radius: 50%;\r\n                    width: 26px;\r\n                    height: 25px;\r\n                    display: inline-block;\r\n                    text-align: center;\r\n                    vertical-align: middle;\r\n                    margin-right: 2px;\r\n                    position: relative;\r\n               }\r\n               #confirmDelete, #successMsg, #warningOK{\r\n                   top: 200px;vertical-align: middle;\r\n               }\r\n    \r\n\r\n#recent-reports{\r\n    table-layout: fixed;\r\n    width: 100%\r\n}\r\n#recent-reports th:first-child{\r\n    width: 150px;\r\n}\r\n#recent-reports th:nth-child(2){\r\n    width: 180px;\r\n}\r\n#recent-reports th:nth-child(3){\r\n    width: 235px;\r\n}\r\n#recent-reports th:nth-child(4){\r\n    width: 202px;\r\n}\r\n#recent-reports th:nth-child(5){\r\n    width: 180px;\r\n}\r\n#recent-reports th:nth-child(6){\r\n    width: 233px;\r\n}\r\n#recent-reports th:last-child{\r\n    width: 70px;\r\n}\r\n#recent-reports tbody tr.report-plan-a{\r\n    background: #f5f5f5;\r\n}\r\n\r\n.report-plan-arrow{\r\n    border-radius: 50%;\r\n    height: 30px;\r\n    width: 30px;\r\n    text-align: center;\r\n    padding: 6px 9px;\r\n}\r\n.padding0{\r\n    padding: 0px;\r\n}\r\n.rounded-num{\r\n    background: #0575b5;\r\n    padding: 3px 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    width: 25px;\r\n    height: 25px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    margin-right: 2px;\r\n}\r\n.report-action-btn span{\r\n  \r\n    padding: 5px;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n.report-plan-arrow{\r\n    border-color: #00a6c6;\r\n    color: #00a6c6;\r\n}\r\n.text-wrap{\r\n    white-space: nowrap;\r\n    width: 27em;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n.text-wrap1{\r\n    white-space: nowrap;\r\n    width: 7em;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n}\r\n.pdficon img{}\r\n    .pdficon{background: transparent !important;\r\n        padding: 0 !important;}\r\n        .xlsicon img{    }\r\n        img {\r\n            vertical-align: top;\r\n        }\r\n        .report-plan-a .report-action-btn{   background: #509fcc;\r\n            width: 151px;\r\n            height: 28px;\r\n            border-radius: 15px;\r\n            text-align: center;\r\n            float: left;}\r\n            table tr td:nth-child(5){width: 100px;}\r\n            table tr th:nth-child(5){width: 100px;}\r\n            .charticon{float: left; padding-left: 20px;}\r\n            .report-action-btn{background:#3cc5d3;   \r\n                width: 151px;\r\n                height: 28px;\r\n                border-radius: 15px;\r\n                text-align: center;\r\n                float: left;}\r\n            .report-scenario table tr td:first-child{width: 20px}\r\n            .report-scenario table tr td:nth-child(2){    width: 264px; max-width: 235px;}\r\n            .report-scenario table tr td:nth-child(3){    width: 620px!important;\r\n                max-width: 645px;}\r\n                .pagination>li>a, .pagination>li>span {\r\n                    border-radius: 50% !important;\r\n                    padding: 5px 0 0 0;\r\n                    height: 27px;\r\n                    width: 27px;\r\n                    text-align: center;\r\n                    margin: 5px 5px 0 0;\r\n                    font-size: 13px;border: none;color: #fff;background: #bcbec0;\r\n                }\r\n                .pagination {    \r\n                    margin: 0;\r\n                  \r\n                }\r\n                .report-plan-a td{padding: 6px 20px;}\r\n                .sce_complete{    background: #0575b5 !important;     }\r\n               .sce_draft{background: #f69a9b !important; }\r\n               .report-scenario table{margin-bottom: 0px;}\r\n               .text-default tr th{    padding: 20px 20px;background: #d9d9d9;}\r\n               .sce-incompledted{\r\n                    background: #bcbec0;\r\n                    padding: 3px 5px;\r\n                    color: #fff;\r\n                    border-radius: 50%;\r\n                    width: 26px;\r\n                    height: 25px;\r\n                    display: inline-block;\r\n                    text-align: center;\r\n                    vertical-align: middle;\r\n                    margin-right: 2px;\r\n                    position: relative;\r\n               }\r\n               .sce-draft{\r\n                    background: orange;\r\n                    padding: 3px 5px;\r\n                    color: #fff;\r\n                    border-radius: 50%;\r\n                    width: 26px;\r\n                    height: 25px;\r\n                    display: inline-block;\r\n                    text-align: center;\r\n                    vertical-align: middle;\r\n                    margin-right: 2px;\r\n                    position: relative;\r\n               }\r\n               #confirmDelete, #successMsg, #warningOK{\r\n                   top: 200px;\r\n               }\r\n               .navbar-nav>li>a{\r\n                padding-top: 0px;\r\n                padding-bottom: 0px;\r\n                padding-left: 0px;\r\n                font-size: 13px;\r\n                margin-left: -7px;\r\n            \r\n            }\r\n            .nav>li>a>img {\r\n                max-width: none;\r\n                width: 32px;\r\n                margin-right: 0px;\r\n                margin-bottom: 3px;\r\n\r\n            }\r\n\r\n            .draft{\r\n                background:#9A0A35;\r\n              }\r\n              \r\n              #recent-reports td{word-wrap: break-word;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
